import { useTranslation } from 'react-i18next';
import env from '@/env';
import { useAtomValue } from 'jotai';
import { navigationGameIdAtom } from '@/atoms/navigation';
import { useMatchRoute } from '../useMatchRoute';

export const useMatchNavigationItems = () => {
  const { t } = useTranslation('navigation');
  const iqGameId = useAtomValue(navigationGameIdAtom);
  const matchRoute = useMatchRoute();

  return [
    {
      id: 'dashboard',
      label: t('crossPlatform.secondary.dashboard'),
      route: `${matchRoute}/dashboard`,
    },
    {
      id: 'match-stats',
      label: t('crossPlatform.secondary.matchStats'),
      route: `https://${env.VITE_IQ_DOMAIN}/_/match/match-stats?matchId=${iqGameId}`, // V2 route
    },
    {
      id: 'race-chart',
      label: t('crossPlatform.secondary.raceChart'),
      route: `${matchRoute}/race-chart`,
    },
    {
      id: 'shot-map',
      label: t('crossPlatform.secondary.shotMap'),
      route: `${matchRoute}/shots`,
    },
    {
      id: 'pass-network',
      label: t('crossPlatform.secondary.passNetwork'),
      route: `https://${env.VITE_IQ_DOMAIN}/_/match/pass-network?matchId=${iqGameId}`, // V2 route
    },
    {
      id: 'corner-touches',
      label: t('crossPlatform.secondary.cornerTouches'),
      route: `${matchRoute}/corners`,
    },
    {
      id: 'pressure-map',
      label: t('crossPlatform.secondary.pressureMap'),
      route: `${matchRoute}/pressure-map`,
    },
    {
      id: 'formations',
      label: t('crossPlatform.secondary.formations'),
      route: `${matchRoute}/formations`,
    },
    {
      id: 'freeze-frame-viewer',
      label: t('crossPlatform.secondary.freezeFrameViewer'),
      route: `${matchRoute}/freeze-frame-viewer`,
    },
  ];
};
